export default (): Auth => ({
  fw_token: "",
  fw_token_timestamp: 0,
  user: null
})
